import { render } from "./ImageSvg.vue?vue&type=template&id=0b28557b"
import script from "./ImageSvg.vue?vue&type=script&lang=js"
export * from "./ImageSvg.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaimevalencia/Documents/PROYECTOS/SERVIDOR_GIT/soporte_bis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__